import React from "react";
import { Box, Grid, Heading, Link, SimpleGrid, Text } from "@chakra-ui/react";
import { useColorModeValue } from "../components/ui/color-mode";

const publicMetricLinks = [
  { label: "All public KPI data", href: "/metrics" },
  { label: "User and customer metrics", href: "/metrics/users" },
];

const HomePublicMetricsSection = () => {
  const bandBg = useColorModeValue("white", "gray.900");
  const subtleBg = useColorModeValue("gray.100", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const mutedTextColor = useColorModeValue("gray.600", "gray.300");
  const linkColor = useColorModeValue("teal.700", "teal.300");

  return (
    <Box as="section" bg={bandBg} borderYWidth="1px" borderColor={borderColor}>
      <Box maxW="1180px" mx="auto" px={{ base: 5, md: 8 }} py={{ base: 10, md: 14 }}>
        <Grid templateColumns={{ base: "1fr", md: "0.9fr 1.1fr" }} gap={8} alignItems="start">
          <Box>
            <Heading as="h2" size="xl">
              Filing-sourced public KPI data
            </Heading>
            <Text mt={3} color={mutedTextColor} lineHeight="1.7">
              Public metric pages collect company-reported operating data, source filing links, and
              historical KPI values that can feed stock valuation assumptions.
            </Text>
          </Box>
          <SimpleGrid columns={{ base: 1, sm: 2 }} gap={3}>
            {publicMetricLinks.map((metricLink) => (
              <Link
                key={metricLink.href}
                href={metricLink.href}
                bg={subtleBg}
                borderWidth="1px"
                borderColor={borderColor}
                borderRadius="md"
                p={4}
                color={linkColor}
                fontWeight="semibold"
              >
                {metricLink.label}
              </Link>
            ))}
          </SimpleGrid>
        </Grid>
      </Box>
    </Box>
  );
};

export default HomePublicMetricsSection;
